(function () {
  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function currentLang() {
    return document.documentElement.getAttribute('data-lang') || 'pt';
  }

  function init() {
    var variants = window.__productVariants || [];

    var optionGroups = document.querySelectorAll('.pdp__option-values');
    var variantInput = document.getElementById('pdp-variant-id');
    var priceEl = document.getElementById('pdp-price');
    var compareEl = document.getElementById('pdp-price-compare');
    var stockEl = document.getElementById('pdp-stock');
    var addBtn = document.getElementById('pdp-add-btn');
    var addLabel = document.getElementById('pdp-add-label');

    function selectedOptions() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.is-selected');
        selected.push(active ? active.getAttribute('data-value') : null);
      });
      return selected;
    }

    function findVariant() {
      var selected = selectedOptions();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null && o !== undefined; });
        return opts.every(function (o, i) { return selected[i] === undefined || selected[i] === null || o === selected[i]; });
      });
    }

    function addLabelMarkup(available) {
      var lang = currentLang();
      if (available) {
        return lang === 'en' ? 'Add to Cart' : 'Adicionar ao Carrinho';
      }
      return lang === 'en' ? 'Sold Out' : 'Esgotado';
    }

    function stockMarkup(variant) {
      var lang = currentLang();
      if (!variant.available) {
        return '<span class="pdp__stock-dot pdp__stock-dot--out"></span>' + (lang === 'en' ? 'Sold Out' : 'Esgotado');
      }
      if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
        return '<span class="pdp__stock-dot pdp__stock-dot--low"></span>' + (lang === 'en' ? 'Only ' + variant.inventory_quantity + ' left' : 'Últimas ' + variant.inventory_quantity + ' unidades');
      }
      return '<span class="pdp__stock-dot"></span>' + (lang === 'en' ? 'In Stock' : 'Em Stock');
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (stockEl) stockEl.innerHTML = stockMarkup(variant);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.innerHTML = addLabelMarkup(variant.available);
      }
      if (variant.featured_image && variant.featured_image.src) {
        var mainImg = document.getElementById('pdp-main-image');
        if (mainImg) mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_800x$2');
      }
    }

    // Colour swatches: painted at runtime from the same name→hex lookup the
    // design tool uses (assets/color-names.js), so a supplier colour like
    // "Millennial Khaki" shows its real shade here too, not just its name.
    document.querySelectorAll('[data-swatch-name]').forEach(function (el) {
      el.style.background = window.hexForColorName ? window.hexForColorName(el.getAttribute('data-swatch-name')) : '#9CA3AF';
    });

    function syncDropdownTrigger(dropdown) {
      var selected = dropdown.querySelector('.pdp__option-value.is-selected');
      if (!selected) return;
      var label = dropdown.querySelector('[data-dropdown-label]');
      var swatch = dropdown.querySelector('[data-dropdown-swatch]');
      if (label) label.textContent = selected.getAttribute('data-value');
      if (swatch) swatch.style.background = window.hexForColorName ? window.hexForColorName(selected.getAttribute('data-value')) : '#9CA3AF';
    }

    document.querySelectorAll('[data-dropdown]').forEach(syncDropdownTrigger);

    document.querySelectorAll('[data-dropdown-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var dropdown = trigger.closest('[data-dropdown]');
        var wasOpen = dropdown.classList.contains('is-open');
        document.querySelectorAll('[data-dropdown].is-open').forEach(function (d) { d.classList.remove('is-open'); d.querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'false'); });
        if (!wasOpen) {
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-dropdown]')) return;
      document.querySelectorAll('[data-dropdown].is-open').forEach(function (d) { d.classList.remove('is-open'); d.querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'false'); });
    });

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp__option-value');
        if (!btn) return;
        group.querySelectorAll('.pdp__option-value').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (group.hasAttribute('data-dropdown')) {
          syncDropdownTrigger(group);
          group.classList.remove('is-open');
        }
        if (variants.length) updateForVariant(findVariant());
      });
    });

    document.querySelectorAll('.pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainImg = document.getElementById('pdp-main-image');
        if (mainImg) mainImg.src = thumb.getAttribute('data-full');
        document.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      var decrease = stepper.querySelector('[data-qty-decrease]');
      var increase = stepper.querySelector('[data-qty-increase]');
      if (!input) return;
      decrease.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, value - 1);
      });
      increase.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = value + 1;
      });
    });

    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion-item]');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
